import React from 'react'
import ResponsiveAppBar from './ResponsiveAppBar'
import { useScrollTrigger, Fade, Tooltip, Box, Fab, Toolbar } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';
import ContactQr from './ContactQr';
import { useNavigate } from 'react-router-dom';
import iaLogo from "../Files/ia.png"

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children?: React.ReactElement;
}

function Header(props: Props) {
    const navigate = useNavigate()
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const anchor = (
            (event.target as HTMLDivElement).ownerDocument || document
        ).querySelector('#back-to-top-anchor');

        if (anchor) {
            anchor.scrollIntoView({
                block: 'center',
                behavior: "smooth"
            });
        }
    };

    function ScrollTop(props: Props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });


        return (
            <Fade in={trigger}>
                <Tooltip title="Remonter en haut de la page">
                    <Box
                        onClick={handleClick}
                        role="presentation"
                        sx={{ position: 'fixed', bottom: 94, right: 32, zIndex: 1200 }}
                    >
                        {children}
                    </Box>
                </Tooltip>
            </Fade>
        );
    }

    return (
        <div>
            <Toolbar id="back-to-top-anchor" className='ibg-nav-spacer' >
                <ResponsiveAppBar />
                <Box zIndex={1}>
                    <ScrollTop {...props}>
                        <Fab className='ibg-fab ibg-fab--light' size="small" aria-label="scroll back to top">
                            <ArrowUpward fontSize='small' />
                        </Fab>
                    </ScrollTop>
                </Box>
            </Toolbar>
            <ContactQr />
            {!window.location.pathname.startsWith('/focusia') ?<Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Tooltip title={"FOCUS IA CHAT"}>
                    <Fab className='ibg-fab ibg-fab--light' style={{ position: 'fixed', bottom: 32, left: 20 }} onClick={(e: any) => { navigate("/focusia"); handleClick(e) }}>
                        <img src={iaLogo} alt="Focus IA" width={28} style={{ borderRadius: 6 }} />
                    </Fab>
                </Tooltip>
            </Box>
            : ""}


        </div>
    )
}

export default Header
